import React, { forwardRef } from "react"

import HiddenSubmit from "components/HiddenSubmit/HiddenSubmit"

interface IFormProps extends React.HTMLProps<HTMLFormElement> {
    wrapperClassName?: string
}

const Form = forwardRef<any, IFormProps>(({
    children,
    wrapperClassName,
    ...props
}, ref) => {
    function handleSubmit(event: React.SubmitEvent<HTMLFormElement>) {
        event.stopPropagation()
        event.preventDefault()

        if (typeof props.onSubmit === "function") {
            props.onSubmit(event)
        }
    }

    return <form {...props} onSubmit={handleSubmit} ref={ref}>
        <HiddenSubmit />
        {/* keep this wrapper to make first-child / last-child work for children */}
        <div className={wrapperClassName}>
            {children}
        </div>
    </form>
})

export default Form
